import React, { Component } from "react";
import { Field } from "redux-form";
import { FormGroup, Label } from "reactstrap";
import Aux from "../../../system/containers/Aux";
import TextInput from "../../../system/fields/TextInput";
import Wysiwyg from "../../../system/fields/Wysiwyg";


class FreeText extends Component {
  constructor(props, leg, index, fields) {
    super(props);
  }

  render() {
    return (
      <Aux>
        <div className="row top-field">
          <FormGroup className="col-12 col-sm-4">
            <Label htmlFor="email">Title</Label>
            <Field
              name={`${this.props.leg}.leg_detail.name`}
              component={TextInput}
              placeholder="Enter your title..."
              type="text"
              autoFocus={true}
            />
          </FormGroup>
          <FormGroup className='col-12'>
              <Label htmlFor='email'>Summary</Label>
              <Field
                name={`${this.props.leg}.leg_detail.summary`}
                component={Wysiwyg}
                placeholder='Sub Title'
                type='text'
                size='sm'
              />
            </FormGroup>
        </div>
      </Aux>
    );
  }
}

export default FreeText;



// WEBPACK FOOTER //
// ./src/containers/Deals/components/FreeText.jsx